import { render } from "./KeyHighlightItem.vue?vue&type=template&id=5284d4aa&scoped=true"
import script from "./KeyHighlightItem.vue?vue&type=script&lang=js"
export * from "./KeyHighlightItem.vue?vue&type=script&lang=js"

import "./KeyHighlightItem.vue?vue&type=style&index=0&id=5284d4aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5284d4aa"]])

export default __exports__